
import Basement from 'vuex-basement'

// TEMP Fix to delete old JsonViewer / autosave mixin large localStorage data sets
if (window.localStorage) {
  var entries = Object.keys(window.localStorage).filter(key => {
    if (key.startsWith("tab-backup")) {
      window.localStorage.removeItem(key)
      return true
    }
    return false
  })
}

export default new Basement({
  includes: [
    {
      path: "ambition.idle"
    },
    {
      path: "ambition.activeSession"
    },
    {
      path: "ambition.userActive"
    },
    {
      path: "userSettings.applicationTabView"
    },
    {
      path: "userSettings.sortby"
    },
    {
      path: "userSettings.tableSettings"
    },
    {
      path: "chat.chatVisible"
    },
    {
      path: "chat.offlineMembers"
    },
    {
      path: "chat.onlineMembers"
    },
    {
      path: "notifications.setNewNotificationStatus"
    },
    {
      path: "notifications.totalCount"
    },
    {
      path: "notes.scratch"
    }
  ]
})
